import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Tag, Pencil, Trash, X } from "lucide-react";
import type { Datapoint } from "@/types/dataset";

interface DatapointListProps {
  datapoints: Datapoint[] | undefined;
  onDeleteDatapoint: (id: string) => void;
  onEditDatapoint: (datapoint: Datapoint) => void;
  onAddSmartTag: (datapoint: Datapoint) => void;
  onDeleteSmartTag: (id: string) => void;
}

export const DatapointList = ({
  datapoints,
  onDeleteDatapoint,
  onEditDatapoint,
  onAddSmartTag,
  onDeleteSmartTag,
}: DatapointListProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Smart Tags</TableHead>
          <TableHead className="w-[150px]">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {datapoints?.map((datapoint) => (
          <TableRow key={datapoint.id}>
            <TableCell>{datapoint.name}</TableCell>
            <TableCell>
              <div className="flex flex-wrap gap-2">
                {datapoint.smart_tags && datapoint.smart_tags.length > 0 ? (
                  datapoint.smart_tags.map((tag) => (
                    <div key={tag.id} className="flex items-center gap-1 bg-muted rounded-full px-2 py-1 text-sm">
                      <Tag className="h-3 w-3" />
                      <span>{tag.tag_value}</span>
                      <button onClick={() => onDeleteSmartTag(tag.id)} className="hover:text-destructive">
                        <X className="h-3 w-3" />
                      </button>
                    </div>
                  ))
                ) : (
                  <span className="text-sm text-muted-foreground">No smart tags</span>
                )}
                <Button variant="outline" size="sm" className="rounded-full" onClick={() => onAddSmartTag(datapoint)}>
                  <Tag className="h-3 w-3 mr-1" />
                  Add Tag
                </Button>
              </div>
            </TableCell>
            <TableCell>
              <div className="flex gap-2">
                <Button variant="outline" size="icon" onClick={() => onEditDatapoint(datapoint)}>
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button variant="destructive" size="icon" onClick={() => onDeleteDatapoint(datapoint.id)}>
                  <Trash className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
